/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Step_Set_Master_DescInputs */

const en_dashboard_step_set_master_desc = /** @type {(inputs: Dashboard_Step_Set_Master_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark one as your AI template`)
};

const de_dashboard_step_set_master_desc = /** @type {(inputs: Dashboard_Step_Set_Master_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markiere einen als deine KI-Vorlage`)
};

const fr_dashboard_step_set_master_desc = /** @type {(inputs: Dashboard_Step_Set_Master_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marque-en un comme ton modèle IA`)
};

const es_dashboard_step_set_master_desc = /** @type {(inputs: Dashboard_Step_Set_Master_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marque uno como su plantilla de IA`)
};

const it_dashboard_step_set_master_desc = /** @type {(inputs: Dashboard_Step_Set_Master_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segna uno come modello AI`)
};

const nl_dashboard_step_set_master_desc = /** @type {(inputs: Dashboard_Step_Set_Master_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markeer er een als je AI-sjabloon`)
};

const pl_dashboard_step_set_master_desc = /** @type {(inputs: Dashboard_Step_Set_Master_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oznacz jedno jako szablon AI`)
};

const fi_dashboard_step_set_master_desc = /** @type {(inputs: Dashboard_Step_Set_Master_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Merkitse yksi AI-mallipohjaksi`)
};

const da_dashboard_step_set_master_desc = /** @type {(inputs: Dashboard_Step_Set_Master_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markér et som din AI-skabelon`)
};

const sv_dashboard_step_set_master_desc = /** @type {(inputs: Dashboard_Step_Set_Master_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Markera en som din AI-mall`)
};

/**
* | output |
* | --- |
* | "Mark one as your AI template" |
*
* @param {Dashboard_Step_Set_Master_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const dashboard_step_set_master_desc = /** @type {((inputs?: Dashboard_Step_Set_Master_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Step_Set_Master_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_dashboard_step_set_master_desc(inputs)
	if (locale === "fr") return fr_dashboard_step_set_master_desc(inputs)
	if (locale === "es") return es_dashboard_step_set_master_desc(inputs)
	if (locale === "it") return it_dashboard_step_set_master_desc(inputs)
	if (locale === "nl") return nl_dashboard_step_set_master_desc(inputs)
	if (locale === "pl") return pl_dashboard_step_set_master_desc(inputs)
	if (locale === "fi") return fi_dashboard_step_set_master_desc(inputs)
	if (locale === "da") return da_dashboard_step_set_master_desc(inputs)
	if (locale === "sv") return sv_dashboard_step_set_master_desc(inputs)
	return en_dashboard_step_set_master_desc(inputs)
});